"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultReplyBar = void 0;
exports.defaultReplyBar = {
    title: 'Contact Us',
    caption: 'Contact Us Now',
    isShow: true,
    whatsapp: {
        isShow: true,
        value: 'https://wa.me/85260150082?text=',
    },
    phone: {
        isShow: true,
        value: '1232',
    },
    callPopup: {
        active: false,
        callUsAt: 'Call Us At',
        callNumber: '1234',
        callPopupTitle: 'Office Hours',
        officeHours: [{ day: 'MONDAY – FRIDAY', time: '9AM - 6PM' },]
    },
    captionLg: '',
    from: 0
};
